import React, { useState } from 'react';
import { Container, Row, Col, Card, FormGroup, Label, Input, Button, CardBody } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import { usePendingWork } from '../../../hooks/workOrder/usePendingWork';
import { usePendingExternaLabs } from '../../hooks/pendingExternaLabs/usePendingExternaLabs';
import Select from 'react-select';
// import './styleDataTable.css';

export const IndexPendingExternaLab = () => {
    const {
        // #region Filters
        mDateRange1, mDateRange2, release_mode, handleCleanLaboratory, handleClean,
        // #endregion 

        handleInputChange, handleSelectValues, loading,
        getPedingWorkLabsExternal, reportPendingExams,
        externalLaboratory, mSelectLaboratoryExt,

        //Indicators
        nameLaboratory, totalNims, totalExam,

        // search Exams
        handleSearchPedingWork,

        //excekl
        exportExcel

    } = usePendingExternaLabs();

    const [globalFilter, setGlobalFilter] = useState('');

    const header = (
        <div className="flex align-items-center justify-content-end">
            <button
                className="p-button p-button-success"
                onClick={() => exportExcel()}
                title="Reporte de laboratorios externos"
                style={{
                    alignItems: "center",
                    padding: "5px 8px",
                    height: "35px",
                    width: "35px",
                    fontSize: "0.9rem",
                }}
            >
                <i className="pi pi-file-excel" style={{ fontSize: "1rem", marginRight: "5px" }}></i>
            </button>
        </div>
    );


    const releaseOptions = [
        { value: '0', label: 'Todos' },
        { value: '1', label: 'Liberados' },
        { value: '2', label: 'Pendientes de liberar' },
    ];

    return (
        <div className='container-global-zoom p-2'>

            {/* Filters */}
            <Card>
                <CardBody className='p-1'>
                    <FormGroup>

                        <Row>

                            <Col xs="12" md="3" className='text-center f-s-italic text-info p-2'>
                                <Label className="f-w-600 f-12 badge">&nbsp;</Label>
                                <h5 className='f-16 f-w-700'>Pendientes - Laboratorio de Referencia</h5>

                            </Col>

                            <Col xs="12" sm="6" md="2" className="mb-2 d-flex flex-column align-items-start justify-content-end">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Fecha de inicio</Label>
                                <Input
                                    type="date"
                                    value={mDateRange1}
                                    name="mDateRange1"
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm input-air-primary b-r-9"
                                    placeholder="YYYY-MM-DD"
                                />
                            </Col>

                            <Col xs="12" sm="6" md="2" className="mb-2 d-flex flex-column align-items-start justify-content-end">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Fecha de cierre</Label>
                                <Input
                                    type="date"
                                    value={mDateRange2}
                                    name="mDateRange2"
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm input-air-primary b-r-9"
                                    placeholder="YYYY-MM-DD"
                                />
                            </Col>

                            <Col xs="12" sm="6" md="2" className="mb-2 mt-4">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Estatus</Label>
                                <Select
                                    name="release_mode"
                                    placeholder="Selecciona un estatus"
                                    options={releaseOptions}
                                    onChange={(e) => handleSelectValues(e, 'release_mode')}
                                    value={release_mode}
                                    menuPortalTarget={document.body}
                                    style={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                />
                            </Col>

                            <Col xs="12" sm="6" md="3" className="mb-2 d-flex flex-column align-items-start justify-content-end">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Acciones</Label>
                                <div>
                                    <Button
                                        onClick={(e) => getPedingWorkLabsExternal(e, true)}
                                        outline
                                        color="primary"
                                        size="sm"
                                        disabled={loading}
                                    >
                                        Filtrar
                                    </Button>
                                    <Button
                                        onClick={handleClean}
                                        outline
                                        color="danger"
                                        size="sm"
                                        disabled={loading}
                                        className="ml-2"
                                    >
                                        Limpiar
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </FormGroup>

                </CardBody>
            </Card>


            <Card>
                <CardBody className='pl-2 pb-2 pt-2' >
                    <Row>
                        <Col sm="4" style={{ borderRight: "1px solid rgba(7, 34, 109, 0.42)" }} >
                            <Col sm="12" className='p-l-0 p-r-0' >
                                <Row>
                                    <Col sm="3">
                                        <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/laboratorio.png")} style={{ width: "60px", height: "60px" }} />
                                    </Col>
                                    <Col sm="9" >
                                        <label className='f-w-500 d-block text-center' style={{ fontSize: "13px" }}>
                                            Laboratorio
                                        </label>
                                        <div className='text-center widgets-ind'>
                                            {
                                                loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                            }
                                            {
                                                !loading && <h4 className='text-success'>{nameLaboratory()} </h4>
                                            }

                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Col>

                        <Col sm="4" style={{ borderRight: "1px solid rgba(7, 34, 109, 0.42)" }} >
                            <Col sm="12" className='p-l-0 p-r-0' >
                                <Row>
                                    <Col sm="3">
                                        <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/patients.png")} style={{ width: "65px", height: "65px" }} />
                                    </Col>
                                    <Col sm="9" >
                                        <label className='f-w-500 d-block text-center' style={{ fontSize: "13px" }}>
                                            Total de Pacientes
                                        </label>
                                        <div className='text-center widgets-ind'>
                                            {
                                                loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                            }
                                            {
                                                !loading && <h4 className='text-success'>{totalNims()} </h4>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Col>

                        <Col sm="4"  >
                            <Col sm="12" className='p-l-0 p-r-0' >
                                <Row>
                                    <Col sm="3">
                                        <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/pendingWork/total-exam.svg")} style={{ width: "60px", height: "60px" }} />
                                    </Col>
                                    <Col sm="9" >
                                        <label className='f-w-500 d-block text-center' style={{ fontSize: "13px" }}>
                                            Total de Exámenes
                                        </label>

                                        <div className='text-center widgets-ind'>
                                            {
                                                loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                            }
                                            {
                                                !loading && <h4 className='text-success'>{totalExam()}</h4>
                                            }

                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Col>


                    </Row>
                </CardBody>
            </Card>




            {/* search*/}

            <Row className='mb-2 justify-content-end'>
                <Col sm="4">
                    <Input type='search' placeholder='Busqueda por Laboratorio, nim o nombre completo...' className='form-control' onChange={handleSearchPedingWork} />
                </Col>
            </Row>


            {/* Table work pending Laborartory External */}

            <Row>
                <Col sm="4">
                    <Card>
                        <div className="ribbon ribbon-clip ribbon-primary">Laboratorios de Referencia</div>
                        <img
                            src={require("../../assets/images/borrar.png")}
                            alt="Excel"
                            title="Limpiar"
                            style={{
                                cursor: 'pointer',
                                width: '25px',
                                height: '25px',
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                zIndex: 1
                            }}
                            onClick={handleCleanLaboratory}
                        />
                        <CardBody className='mt-3'>
                            <div className="d-flex flex-column align-items-center">
                                {externalLaboratory.length > 0 ? (
                                    externalLaboratory.reduce((rows, laborartory, index) => {
                                        if (index % 2 === 0) {
                                            rows.push([laborartory]);
                                        } else {
                                            rows[rows.length - 1].push(laborartory);
                                        }
                                        return rows;
                                    }, []).map((row, rowIndex) => (
                                        <div key={rowIndex} className="d-flex w-100 justify-content-center mb-2">
                                            {row.map((laborartory) => (
                                                <Button
                                                    key={laborartory.value}
                                                    onClick={() => {
                                                        handleSelectValues(laborartory, 'mSelectLaboratoryExt');
                                                        console.log('Seleccionado:', laborartory);
                                                    }}

                                                    color={mSelectLaboratoryExt?.value === laborartory.value ? 'primary' : 'secondary'}
                                                    size="sm"
                                                    className="w-50 mx-1 text-center"
                                                    style={{ fontSize: '12px', padding: '5px 10px' }}
                                                    outline={mSelectLaboratoryExt?.value !== laborartory.value}
                                                >
                                                    {laborartory.label}
                                                </Button>
                                            ))}
                                        </div>


                                    ))
                                ) : (
                                    <p style={{ fontSize: '12px' }}>No hay secciones disponibles</p>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </Col>


                <Col sm="8">
                    <div className='table-responsive'>
                        <DataTable
                            value={reportPendingExams}
                            stripedRows
                            paginator
                            rows={10}
                            header={header}
                            rowsPerPageOptions={[10, 50, 100]}
                            className="data-table p-datatable-striped p-datatable-sm"
                            responsiveLayout="scroll"
                            globalFilter={globalFilter}
                            emptyMessage={
                                <div className="text-center">
                                    <img
                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                        style={{ width: "40%" }}
                                        alt="Sin resultados"
                                    />
                                    <br />
                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                        Sin información de pendientes de laboratorio.
                                    </p>
                                </div>
                            }
                        >
                            {/* Columna índice */}
                            <Column
                                header="#"
                                body={(rowData, { rowIndex }) => rowIndex + 1}
                                style={{ width: '3em', textAlign: 'center', fontSize: "12px" }}
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                            />

                            <Column
                                field="laboratory"
                                header="Laboratorio"
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                            />

                            <Column
                                field="nim"
                                header="NIM"
                                body={(rowData) => (
                                    <a
                                        href={`/captura-resultados/${rowData.nim}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {rowData.nim}
                                    </a>
                                )}
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                            />


                            <Column
                                header="Nombre del Paciente"
                                body={(rowData) => `${rowData.name} ${rowData.paternal_surname} ${rowData.maternal_surname}`}
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}

                            />


                            <Column
                                field="exam"
                                header="Exámen"
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                            />

                            <Column
                                field="cost"
                                header="Costo"
                                sortable
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                body={(rowData) => {
                                    const cost = parseFloat(rowData.cost);
                                    return isNaN(cost) ? '' : `$${cost.toFixed(2)}`;
                                }}

                            />


                            <Column
                                field="study_delivery"
                                header="Fecha promesa"
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                            />




                            <Column
                                field="price"
                                header="Precio"
                                sortable
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                body={(rowData) => {
                                    const price = parseFloat(rowData.price);
                                    return isNaN(price) ? '' : `$${price.toFixed(2)}`;
                                }}

                            />

                            <Column
                                field="released"
                                header="Estatus"
                                sortable
                                headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                body={(rowData) => (
                                    <span className={`badge ${rowData.released ? 'badge-success' : 'badge-warning'}`}>
                                        {rowData.released ? 'Liberado' : 'Pendiente de liberar'}
                                    </span>
                                )}
                            />

                        </DataTable>

                    </div>
                    <br /><br />
                </Col>
            </Row>
        </div>

    );
};
